<template>
  <div class="addon-container">
    <addon-group
      v-for="(spec, index) in addonList"
      :spec="spec"
      :isClicked="isClicked"
      v-model="addonList[index].selectedItem"
      @update:modelValue="(val) => onColorClick(spec.name, val)"
      @disabled-color="onDisabledColor"
      :key="index">
    </addon-group>
    <div class="addon-btns">
      <ap-button
        type="primary"
        size="small"
        v-show="!submitSatus"
        :disabled="isDisabled"
        @click="onClick"
        >Continue</ap-button
      >
      <img src="https://img66.anypromo.com/frontimg/2023/Icon/loader.gif" alt="" class="submit-loading" v-show="submitSatus">
    </div>
  </div>
</template>
<script lang="ts"></script>
<script setup lang="ts">
import {  type SpecItem } from '../../types'
import { computed, inject,  ref } from 'vue'
import AddonGroup from './addonGroup.vue'
import { SHOW_PRICE_GROUP_KEY } from '../../token'
import { ApButton } from '@anypromo/components-pc'
import { useAddon } from '../../store/modules/addon'

const isDisabled = ref(false)
const isClicked = ref(false)
const addonState = useAddon()
const addonList = computed(() => addonState.getSelectedList)

const showPriceGroup = inject(SHOW_PRICE_GROUP_KEY)
if (!showPriceGroup) {
  console.warn('build error')
}

const props = withDefaults(
  defineProps<{
    submitSatus: boolean
  }>(),
  {
    submitSatus: false,
  }
)
const emit = defineEmits<{
  (e: 'go-next'): void
  (e: 'update-view'): void
}>()

const isValidGroup = () => {
  const selectedValues = addonState.getSelectedList

  const isValid = selectedValues.every((val) => {
    return !!val.selectedItem
  })
  // bus.emit('addon-validate')
  return isValid
}

const onClick = () => {
  isClicked.value = true
  const isValid = isValidGroup()
  isDisabled.value = !isValid
  if (isDisabled.value) {
    return
  }
  emit('go-next')
}

const onColorClick = async (name: string, val: SpecItem | undefined) => {
  if (isClicked.value) {
    const isValid = isValidGroup()
    isDisabled.value = !isValid
  }
  emit('update-view')
}

const onDisabledColor = (name: string, color: SpecItem) => {
  showPriceGroup!({
    type: 'addon',
    value: {
      name: name,
      value: color.value,
      text: color.text
    }
  }).then((data) => {
    console.log('showPriceGroup')
  })
}
</script>
<style lang="less">
.addon-container {
  padding: 15px 15px 0;
}

.addon-btns {
  padding: 0;
  margin: 15px 0;
}
</style>
